import classNames from 'classnames';
import { useCallback, useEffect } from 'react';
import { Button, Heading } from 'yoso';
import { useChallengeScore } from '~/components/Challenge/Score/ChallengeScore.hooks';
import { Translation } from '~/components/I18n';
import { Exclamation2 } from '~/components/Icon/Exclamation2';
import { Alert, AlertProps, styles as alertStyles } from '~/components/Modal/Alert/Alert';
import { format } from '~/components/Util/number';
import styles from './ScoreUpFulfilledPopup.module.scss';

export type ScoreUpFulfilledPopupProps = {
  className?: string;
} & AlertProps;

export const ScoreUpFulfilledPopup = ({ className, onConfirm }: ScoreUpFulfilledPopupProps) => {
  const {
    data: { purchaseRewardScore },
  } = useChallengeScore();

  const handleConfirm = useCallback(() => {
    onConfirm?.();
    location.href = `${import.meta.env.VITE_CITIZEN_STORE_URL}/marketplace`;
  }, [onConfirm]);

  useEffect(() => {
    // TODO: impression event might need to be updated with dosi-analytics npm interface
    gtag('event', 'impression_scorelimit_popup');
  }, []);

  return (
    <Alert
      className={classNames(styles.root, className)}
      title={<Translation name="citizen_scoreup_limit_title" />}
      icon={<Exclamation2 />}
      description={<Translation name="citizen_scoreup_limit_desc" />}
      confirmButton={
        <Button
          className={classNames(alertStyles.button, alertStyles.confirmButton)}
          color="primary"
          onClick={handleConfirm}
          data-event="click"
          data-event-target="gotomarket_btn_in_scoreuplimit_popup">
          <Translation name="citizen_scoreup_limit_btn" />
        </Button>
      }>
      <div className={styles.content}>
        <Heading level={6} className={styles.label}>
          <Translation name="citizen_scoreup_limit_purchasescore_title" />
        </Heading>
        <p className={styles.value}>
          <Translation
            name="citizen_unit_score"
            options={[format(purchaseRewardScore, { zeroAsEmpty: true })]}
          />
        </p>
      </div>
    </Alert>
  );
};
